module.exports = __webpack_public_path__ + "static/images/map/markers/pin_6C7AE0.svg";